<template>
    <component :is="'VuePerfectScrollbar'" ref="filterScroll" class="filters_scroll_area"  :settings="settings" :key="$vs.rtl">
        <div class="todo__filters-container">
            <div>
                <vs-divider class="mb-0 mt-0"></vs-divider>

                <!-- Кнопка сброса фильтра -->
                <div class="px-6 py-4">
                    <div class="flex cursor-pointer" @click="filterRouteAll()">
                        <feather-icon icon="LayersIcon" svgClasses="h-6 w-6"></feather-icon>
                        <span class="text-lg ml-3">{{$t('show_all')}}</span>
                    </div>
                </div>

                <vs-divider class="mb-0 mt-0"></vs-divider>

                <!-- Фильтра -->
                <div class="px-6 py-4 border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid" v-for="(filter, name, index) in filterActive" :key="`f_${index}`">
                    <h5 class="mb-3">{{$t(name)}}</h5>

                    <multiselect
                        v-model="filterActive[name]"
                        :options="dynamicOptions(name)"
                        :selectedLabel="$t('selected')"
                        :placeholder="$t(name)"
                        @open="openSelect(name)"
                        class="filter_select"
                        @close="selectClose"
                        :loading="isLoading[name]"
                        label="name"
                        @select="multiselectAction($event, name)"
                        @remove="multiselectRemove($event, name)"
                        deselectLabel=""
                        selectLabel=""
                        track-by="uid">
                            <div slot="noOptions">
                                {{$t('no_data_text')}}
                            </div>
                    </multiselect>
                </div>

                <div class="px-6 py-4 lg:hidden">
                    <vs-button @click="sidebarToggle()" class="w-full">{{$t('apply')}}</vs-button>
                </div>
            </div>
        </div>
    </component>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapActions, mapMutations, mapState } from "vuex"

export default {
    props: {
        itemHandler: {
            type: Function,
            default: () => {}
        },
        sidebarToggle: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            isLoading: {
                app_type: false,
                status: false
            },
            filterActive: {
                app_type: null,
                status: null
            },
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            }
        }
    },
    created: function() {
        // Запрашиваем активные фильтры
        this.setActiveFilters()
    },
    mounted: function () {
        this.$nextTick(function () {
            this.openSelect('app_type')
        })
    },
    computed: {
        ...mapState({
            app_type: state => state.coo.app_type,
            status: state => state.coo.status
        }),
    },
    methods: {
        ...mapActions({
            fetchAppTypes: 'coo/fetchAppTypes'
        }),
        ...mapMutations({
            clearFilter: 'coo/CLEAR_FILTER',
            setActiveFilter: 'coo/SET_ACTIVE_FILTER'
        }),
        filterRouteAll() {
            this.$emit('closeopensidebar')

            // При нажатии на кнопку показать все, убираем все фильтры и обновляем список
            if(Object.keys(this.$route.query).length) {
                this.$router.push({name: 'coo'})
                for (let query in this.filterActive) {
                    this.filterActive[query] = ''
                }
                this.$store.commit('coo/SET_ACTIVE_TYPE', null)
                this.updateStudentList()
            }
        },
        updateStudentList() {
            // Чистим текущий список пользователей
            this.$store.commit('coo/CLEAR_LIST')

            // Запрашиваем новый список
            this.itemHandler({update:true})
        },
        async filterParamsRefresh(key, query) {
            // Обновляем роут
            await this.$router.push({query})
        },
        async multiselectAction (item, key) {
            this.$emit('closeopensidebar')

            // При выборе селекта, генерируем новый query
            let query = Object.assign({}, this.$route.query)
            query[key] = item.uid
            await this.filterParamsRefresh(key, query)

            if(key === 'app_type') {
                this.$store.commit('coo/SET_ACTIVE_TYPE', item)
                this.$store.commit('coo/CLEAR_GENERATED_FORM')
            }

            // Обновляем список
            this.updateStudentList()
        },
        async multiselectRemove (item, key) {
            this.$emit('closeopensidebar')

            // При удаление селекта, удаляем его из роута
            let query = Object.assign({}, this.$route.query)
            delete query[key]
            await this.filterParamsRefresh(key, query)

            if(key === 'app_type') {
                this.$store.commit('coo/SET_ACTIVE_TYPE', null)
                this.$store.commit('coo/CLEAR_GENERATED_FORM')
            }

            // Обновляем список
            this.updateStudentList()
        },
        dynamicOptions(name) {
            // Так как поле настроек видимости выводиться в цикле, через эту функцию подставляем нужные данные в поле
            return this[name]
        },
        selectClose() {
            // Инициализируем скролл
            this.$refs['filterScroll'].__init()
        },
        async openSelect(type) {
            // Останавливаем скролл
            this.$refs['filterScroll'].__uninit()
            // События открытия выпадающего списка, при открытии либо запрашиваем данные для поля с сервера, либо получаем со стора ранее запрошенные данные
            try {
                // Включаем у селекта индикатор загрузки
                this.isLoading[type] = true
                await this.$store.dispatch('coo/checkSelectType', {type, query: this.$route.query})
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger',
                })
            } finally {
                // Отключаем у селекта индикатор загрузки
                this.isLoading[type] = false
            }
        },
        async setActiveFilters() {
            // Если в query есть данные, проходим по ним циклом, запрашиваем нужные фильтры и делаем их активными
            if(Object.keys(this.$route.query).length) {
                for (let key in this.$route.query) {

                    try {
                        if(Object.keys(this.filterActive).includes(key)){
                            this.isLoading[key] = true
                            const res = await this.$store.dispatch('coo/checkSelectType', {type: key, query: this.$route.query})
                            this.filterActive[key] = res.find(item =>  item.uid === this.$route.query[key])
                            if(key === 'app_type')
                                this.$store.commit('coo/SET_ACTIVE_TYPE', this.filterActive[key])
                        }
                    } catch(e) {
                        console.error(e);
                        this.$vs.notify({
                            text: this.$t('error'),
                            color: 'danger',
                        })
                    } finally {
                        this.isLoading[key] = false
                    }
                }
            }
        }
    },
    components: {
        VuePerfectScrollbar
    }
}
</script>
